import styles from './Badge.module.scss';

import * as React from 'react';
import { css } from '../../util/Css';

declare const healConfig: any;

type Props = {
  text: string;
  className?: string;
  style?: React.CSSProperties;
};

export const Badge = (props: Props): JSX.Element => {
  return (
    <div className={css(styles.container, props.className)} style={props.style}>
      {props.text}
    </div>
  );
};

export const BadgeEnvironment = (): JSX.Element | null => {
  if (healConfig.env === 'prd') {
    return null;
  }

  let className = styles.red;
  if (healConfig.env === 'dev') {
    className = styles.teal;
  } else if (healConfig.env === 'qa') {
    className = styles.orange;
  }
  return <Badge text={healConfig.env} className={className} style={{ width: 40 }} />;
};
